import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyCAMChunks',
        resolve: () => require.resolveWeak('./HomeWrapper'),
        path: () => path.join(__dirname, './HomeWrapper'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "HomeWrapperChunks" */ './HomeWrapper'), // css name
            ]).then((proms) => proms[0]),
    }),
    LazyComponent.loaderResource
);
